import { render, staticRenderFns } from "./TenderLots.vue?vue&type=template&id=36c415d5"
import script from "./TenderLots.vue?vue&type=script&lang=js"
export * from "./TenderLots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports